@if (form) {
  <div class="row">
    <div class="col-12">
      <p><span [innerHTML]="form.question_name"></span> @if (form.question_required) {
        <span class="required">*</span>
      }</p>
      <!-- p-select ไม่รองรับการ render rich text ผ่าน optionLabel ตรงๆ (แสดงเป็น plain text เสมอ) — คงไว้แบบเดิม ไม่แปลงเป็น innerHTML เพื่อไม่ให้กระทบ filter/keyboard nav ของ p-select -->
      <p-select class="dropdown-field mt-2" [options]="dropdownOptions" optionLabel="choice_name"
        optionValue="question_choice_id" optionDisabled="_full" placeholder="เลือก..." [disabled]="form.view"
      appendTo="body" [(ngModel)]="value" (onChange)="onChange()"></p-select>
    </div>
  </div>
}
